import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const getRoleLabel = (roleId) => {
  const roles = { 1: 'Admin', 2: 'Support Staff', 3: 'Doctor', 4: 'Patient' };
  return roles[roleId] || 'User';
};

const ImpersonationBanner = () => {
  const { user, isImpersonating, returnToSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  if (!isImpersonating) return null;

  const handleReturn = () => {
    const success = returnToSuperAdmin();
    if (success) {
      navigate('/superadmin/user-directory');
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '8px',
        filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.22))',
      }}
    >
      {/* Expanded info panel */}
      {expanded && (
        <div
          style={{
            background: 'linear-gradient(135deg, #f59e0b, #d97706)',
            color: '#1a1a1a',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '0.8rem',
            fontWeight: 600,
            maxWidth: '260px',
            animation: 'fadeSlideUp 0.18s ease',
          }}
        >
          <div className="d-flex align-items-center gap-2 mb-2">
            <i className="bi bi-shield-lock-fill"></i>
            <span>Support Mode Active</span>
          </div>
          <div className="mb-1" style={{ fontWeight: 400, fontSize: '0.78rem' }}>
            Logged in as <strong>{getRoleLabel(user?.role_id)}</strong>: <strong>{user?.full_name || 'User'}</strong>
          </div>
          {user?.hospital_name && (
            <div style={{ fontWeight: 400, fontSize: '0.75rem', opacity: 0.85 }} className="mb-2">
              {user.hospital_name}
            </div>
          )}
          <button
            onClick={handleReturn}
            style={{
              width: '100%',
              background: '#1a1a1a',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '6px 12px',
              fontWeight: 700,
              fontSize: '0.78rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
            }}
          >
            <i className="bi bi-arrow-return-left"></i>
            Return to SuperAdmin
          </button>
        </div>
      )}

      {/* Floating toggle button */}
      <button
        onClick={() => setExpanded((prev) => !prev)}
        title={expanded ? 'Close' : 'Support Mode — click to expand'}
        style={{
          background: 'linear-gradient(135deg, #f59e0b, #d97706)',
          color: '#1a1a1a',
          border: 'none',
          borderRadius: '50px',
          padding: '10px 18px',
          fontWeight: 700,
          fontSize: '0.82rem',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          whiteSpace: 'nowrap',
          transition: 'transform 0.15s, box-shadow 0.15s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <i className={`bi ${expanded ? 'bi-x-lg' : 'bi-shield-lock-fill'}`}></i>
        <span className="d-none d-sm-inline">
          {expanded
            ? 'Close'
            : `Support: ${user?.hospital_name || ''} | ${getRoleLabel(user?.role_id)} | ${user?.full_name || 'User'}`}
        </span>
        <span className="d-inline d-sm-none">{expanded ? 'Close' : 'Support'}</span>
      </button>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ImpersonationBanner;
